// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__DB8ul","heroText":"Hero_heroText__Odbk5"};